<!-- @format -->

<template>
  <div>
    <div class="ui">
      <div class="ui attached message">
        <div class="content">
          <div class="ui compact form fluid">
            <div class="ui fields" style="margin: 0 0 0 0; padding: 0 0 0 0">
              <div class="ui field" style="margin: 0 0 0 0; padding: 0 0 0 0">
                <input
                  @change="handleLabelChange"
                  v-model="contributionLabel"
                />
              </div>
              <div v-if="keyIndex != 1" class="ui field">
                <div
                  class="ui small red button"
                  @click.prevent="removeContribution"
                >
                  x
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ui attached segment">
        <div class="ui form fluid">
          <div class="ui field">
            <label>Start at Age</label>
            <input
              @change="handleChange"
              v-model.number="contributionStartYear"
            />
            <span style="color: red" v-if="contributionStartYear < currentAge">
              <small>
                Must be greater or equal to current age
                {{ currentAge }}
              </small>
            </span>
          </div>
          <div class="ui field">
            <label>
              Contribution
              <small v-if="contributionStartYear - currentAge > 0">
                ( {{ shortCurrency
                }}{{
                  formatNr(
                    discounted(contribution, contributionStartYear - currentAge)
                  )
                }}
                in today's terms )
              </small>
            </label>

            <currency-input
              @change="handleChange"
              v-model.number="contribution"
              :currency="currency"
            />
          </div>
        </div>
        <div>
          <v-select
            @input="handleChange"
            label="text"
            :reduce="(g) => g.value"
            v-model="contributionFrequency"
            :options="contributionPayoutFrequencies"
          ></v-select>
        </div>
        <div class="ui form">
          <div class="ui field">
            <label>grow contribution by (%)</label>
            <input @change="handleChange" v-model.number="contributionGrowth" />
          </div>
        </div>
        <div>
          <v-select
            @input="handleChange"
            label="text"
            :reduce="(g) => g.value"
            v-model="contributionGrowthFrequency"
            :options="contributionGrowthOptions"
          ></v-select>
        </div>
        <div class="ui form">
          <div class="ui field">
            <label>Contribution to last until age</label>
            <input @change="handleChange" v-model.number="contributionToLast" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import numeral from "numeral";
import vSelect from "vue-select";

import "vue-select/dist/vue-select.css";

export default {
  name: "IncomeInput",
  components: { vSelect },
  props: [
    "currency",
    "shortCurrency",
    "keyIndex",
    "contributionLabel",
    "accounts",
    "contribution",
    "contributionFrequency",
    "contributionGrowth",
    "contributionGrowthFrequency",
    "contributionToLast",
    "contributionStartYear",
    "currentAge",
    "applyContribution",
    "aaType",
  ],
  data() {
    return {
      contributionGrowthOptions: [
        { value: 1, text: "every year" },
        { value: 2, text: "every 2nd year" },
        { value: 3, text: "every 3rd year" },
        { value: 4, text: "every 4th year" },
        { value: 5, text: "every 5th year" },
        { value: 6, text: "every 6th year" },
        { value: 7, text: "every 7th year" },
        { value: 8, text: "every 8th year" },
        { value: 9, text: "every 9th year" },
        { value: 10, text: "every 10th year" },
      ],

      contributionPayoutFrequencies: [
        { value: 12, text: "per month" },
        { value: 3, text: "per quarter" },
        { value: 1, text: "per annum" },
      ],
    };
  },
  computed: {
    expectedInflationRate() {
      if (this.aaType == "Simple" && this.currency == "ZAR") return 0.055;
      if (this.aaType == "Extended" && this.currency == "ZAR") return 0.05;
      if (this.currency == "USD") return 0.025;

      return 0.055;
    },
  },
  methods: {
    formatNr(val, fmt) {
      if (fmt) {
        return numeral(val).format(fmt);
      } else {
        return numeral(val).format("0,0.0a");
      }
    },
    discounted(val, years) {
      return val / Math.pow(1 + this.expectedInflationRate, years); // finlation adjusted
    },
    handleChange() {
      // construct withdrawal weights
      //let weights = [];

      this.$emit("handleInvestmentChanged", {
        accounts: this.accounts,
        keyIndex: this.keyIndex,

        contribution: this.contribution,
        contributionFrequency: this.contributionFrequency,
        currentAge: this.currentAge,
        contributionGrowth: this.contributionGrowth,
        contributionGrowthFrequency: this.contributionGrowthFrequency,
        contributionToLast: this.contributionToLast,
        contributionStartYear: this.contributionStartYear,

        // adhocCashFlow: this.adhocCashFlow
        //  public incomeGrowth: number = 0;
        // public incomeGrowthFrequency: number = 1; // every 1 yr, 2 year, ...
      });
    },
    handleLabelChange() {
      // construct withdrawal weights
      //let weights = [];

      this.$emit("handleContributionLabelChanged", {
        contributionLabel: this.contributionLabel,
      });
    },
    removeContribution() {
      // construct withdrawal weights
      //let weights = [];
      this.$emit("removeAdditionalContribution", {
        keyIndex: this.keyIndex,
      });
    },
    init() {},
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped>
.selecthover tr {
  cursor: pointer;
}
</style>
